/**
 * 篩選負號位置、小數點數量、僅允許數字
 * @param {string} str
 * @param {Boolean} negative
 * @returns {string}
 */
 export function clearNoNum(str, negative, decimal = true) {
  str = String(str)
  const t = str.charAt(0);
  //先把非數字的都替換掉，除了數字和.
  str = str.replace(/[^\d.]/g, "");
  //是否允許小數位
  if (decimal === false) {
    str = str.replace(/[^\d]/g, "");
  }
  //必須保證第一個為數字而不是. 
  str = str.replace(/^\./g, "");
  //保證只有出現一個.而沒有多個. 
  str = str.replace(/\.{2,}/g, ".");
  //保證.只出現一次，而不能出現兩次以上 
  str = str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  //如果字串長度大於1,當第1位為0但第2位不為小數點,將第1位0移除
  if (str.length > 1 && str.charAt(0) === '0' && str.charAt(1) !== '.') {
    str = str.replace("0", "")
  }
  //如果原第1位是負號且允取負數，則允許新增
  if (t === '-' && negative) {
    str = '-' + str;
  }
  return str
}

export function passwordFormat(str) {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,20}$/; 
  return regex.test(str)
}